var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNavigationAndActionWarningSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Basics",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Basics/Icons",
    transform: "translate(-445.000000, -711.000000)",
    fill: "#262626"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Navigation-and-action/Warning/Small",
    transform: "translate(445.000000, 711.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14,12 C11.791,12 10,13.791 10,16 L10,22 C12.209,22 14,20.209 14,18 L14,12 Z M25,17 L25,25 L7,25 L7,17 C7,12.029 11.029,8 16,8 C20.971,8 25,12.029 25,17 L25,17 Z M4,30 L28,30 L28,27 L4,27 L4,30 Z M15,4 L17,4 L17,0 L15,0 L15,4 Z M28,16 L32,16 L32,14 L28,14 L28,16 Z M8.404,6.71 L5.873,3.613 L4.324,4.879 L6.856,7.976 L8.404,6.71 Z M25.144,7.976 L27.676,4.879 L26.128,3.613 L23.596,6.71 L25.144,7.976 Z M0,16 L4,16 L4,14 L0,14 L0,16 Z",
    id: 210
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavigationAndActionWarningSmall);
export default __webpack_public_path__ + "static/media/navigation-and-action-warning-small.975225f6.svg";
export { ForwardRef as ReactComponent };